(function TourSearch($, Adzuki)
{
	"use strict";
	var $tourSheetBtn = $('.tour-sheet-link');
	var tourSheetLink = $tourSheetBtn.attr('href');

	$(document)
		.ready(
			function documentReady() {

				$('.display-image img')
					.on(
						'error',
						function replaceBrokenImage(e) {
							$(this).attr('src', Adzuki.base_uri + '/adzuki/images/no-image.jpg');
						}
					)
				;

				$('.departures .day')
					.click(
						function selectDeparture() {
							var $self      = $(this);
							var $container = $(this).parent('.days');
							var ids        = $self.attr('data-departure-id');
							var id;
							var departures;

							$('.selected').removeClass('selected');
							$('.first').removeClass('first');
							$('.last').removeClass('last');

							ids = ids.split(' ');
							id  = ids[ids.length - 1];

							if (id) {
								departures  = $container.find('.day[data-departure-id~='+id+']').addClass('selected');
								departures.addClass('selected');
								departures.first().addClass('first');
								departures.last().addClass('last');
								showPrices(id);
								modifyTourSheetLink(id);
								console.log('fired');
							}
						}
					)
				;

				$('.departures .day.range')
					.click(
						function selectDepartureRange() {
							var $self     = $(this);
							var duration  = $self.attr('data-duration');
							var $days     = $self.nextAll("*:lt("+(duration - 1)+")");

							$('.selected').removeClass('selected');
							$('.first').removeClass('first');
							$('.last').removeClass('last');

							$self.addClass('selected first');
							$days.addClass('selected');
							$days.last().addClass('last');

						}
					)
				;

				$('.departures .calendar .month-select')
					.click(
						function changeMonth(event) {
							var $self     = $(this);
							var calendar  = $self.parents('.calendar');
							var next      = calendar.next('.calendar');
							var prev      = calendar.prev('.calendar');

							event.preventDefault();

							if ($self.hasClass('next') && next.length) {
								calendar.removeClass('show');
								next.addClass('show');
							}

							if ($self.hasClass('prev') && prev.length) {
								calendar.removeClass('show');
								prev.addClass('show');
							}
						}
					)
				;
			}
		)
	;

	function showPrices(id) {
		var price_group = $(".price-group[data-departure-id='" + id +"']");

		$('.prices .price-group').removeClass('show');
		price_group.addClass('show');

	}

	function modifyTourSheetLink(id) {
		if ($tourSheetBtn.length > 0) {
			$tourSheetBtn.attr('href', tourSheetLink + '/departure_id:' + id);
		}
	}


}(jQuery, window.Adzuki || {}));
